import { windowWidth } from "src/styles/global";
import styled from "styled-components";

const FormContainer = styled.form`
  overflow-y: auto;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding-top: 7px;
  padding-bottom: 130px;

  .default-field {
    width: 100%;
    max-width: 420px;
    margin-bottom: 16px;

    .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-color: ${({ theme }) => theme.brand.navy};
    }

    .MuiInputLabel-root.Mui-focused {
      color: ${({ theme }) => theme.brand.navy};
    }
  }

  .multi-rows-field {
    padding-bottom: 25px;
  }

  @media ( max-width: ${windowWidth.mobile.large} ) {
    padding-left: 5px;
    padding-right: 5px;

    ::-webkit-scrollbar {
      width: 1px;
    }
  }
`;

const FormButtons = styled.div`
  display: flex;
  gap: 16px;

  .delete-button {
    background-color: ${({ theme }) => theme.colors.error} !important;

    &.no-permission {
      background-color: #adaaaa !important;
      color: #3f3f3f;
    }
  }

  .no-permission {
    pointer-events: auto !important;
    cursor: not-allowed !important;
  }

  @media ( max-width: ${windowWidth.mobile.large} ) {
    flex-direction: column;
    width: 100%;
  }
`;

export { FormContainer, FormButtons };